var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4088 16.7162V21.9928H19.3496V17.0698C19.3496 15.8337 18.9079 14.9896 17.8003 14.9896C16.955 14.9896 16.4528 15.5579 16.2311 16.1082C16.1505 16.3049 16.1298 16.578 16.1298 16.8538V21.9926H13.0703C13.0703 21.9926 13.1114 13.6547 13.0703 12.7916H16.13V14.0955C16.1238 14.1058 16.1152 14.1158 16.1097 14.1256H16.13V14.0955C16.5365 13.4699 17.2616 12.5756 18.8871 12.5756C20.8999 12.5756 22.4088 13.8906 22.4088 16.7162ZM9.86985 8.35645C8.82334 8.35645 8.13867 9.04339 8.13867 9.94594C8.13867 10.8293 8.80349 11.5361 9.8297 11.5361H9.84955C10.9166 11.5361 11.58 10.8293 11.58 9.94594C11.5597 9.04339 10.9166 8.35645 9.86985 8.35645ZM8.32051 21.9928H11.3788V12.7916H8.32051V21.9928Z",
    fill: "#91A4CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b1e0743a28952d2961ab94ad52bbac54.svg";
export { ForwardRef as ReactComponent };